module.exports = __webpack_public_path__ + "img/human_41.54ca50c6.png";